module.exports = __webpack_public_path__ + "img/bgaming.cdf4bddd.svg";